import { object } from "yup";

import { policyNumber } from "@covertree/utils";

export interface MissingPolicyDetailsForm {
  policyLocator: string;
}

export const missingPolicyDetailsValidation = object({
  policyLocator: policyNumber(),
});
